import type { SolrParams } from '#shared/solr'
import { hasSolrParams, solrBookAndArticleResponseSchema } from '~/utils/solr/docs-response'

export function useBookAndArticleQuery(params: MaybeRef<SolrParams | undefined>) {
  return useQuery(useSolrQueryOptions({
    endpoint: 'literature',
    params,
    schema: solrBookAndArticleResponseSchema,
    enabled: hasSolrParams,
  }))
}
